import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'angular-community-manage-job',
  templateUrl: './manage-job.component.html',
  styleUrls: ['./manage-job.component.scss']
})
export class ManageJobComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
